<template>
    <icon-base v-bind="$props">
        <path d="M4 5h16l-6 7v6l-4 2v-8z" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
